import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Button,
  Menu,
  MenuButton, MenuGroup, MenuList
} from "@chakra-ui/react";
import { WBToken } from "../../app/index";
import { useAppConfig } from "../../hooks/useAppConfig";

export const User = (user: WBToken) => {
  const { primaryColor } = useAppConfig();
  return (
    <Menu>
      <MenuButton as={Button} leftIcon={<ArrowForwardIcon />}
        color={primaryColor} bgColor="#ffffff" fontSize={["xs", "sm", "md"]}
        size={["xs", "sm"]}
      >
        {`Il tuo saldo`}
      </MenuButton>
      <MenuList zIndex="201">
        <MenuGroup title={`Credito Residuo: `} fontWeight={"normal"}></MenuGroup>
        <MenuGroup title={`${user.credit100 + user.credit51c3}€`}></MenuGroup>
        <MenuGroup title={`di cui Buoni (art51c3): `} fontWeight={"normal"}></MenuGroup>
        <MenuGroup title={`${user.credit51c3}€`}></MenuGroup>
      </MenuList>
    </Menu>
  );
};
